import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RecurringInvoiceTemplate, RecurringInvoiceTemplateCreate, RecurringInvoiceTemplateFilter } from '../data/recurringInvoiceTemplate';

export function createRecurringInvoiceTemplateService(client: AxiosInstance) {
  return createCrudService<RecurringInvoiceTemplate, RecurringInvoiceTemplateCreate, RecurringInvoiceTemplateFilter>(
    client,
    '/accounting/RecurringInvoiceTemplate',
    'id',
  );
}

export type RecurringInvoiceTemplateService = CrudService<RecurringInvoiceTemplate, RecurringInvoiceTemplateCreate, RecurringInvoiceTemplateFilter>;
